import { LiveVideoSkinElement } from '../../presets/live-video/skin';
import { safeDefine } from '../../registration/safe-define';
import './ui';

safeDefine(LiveVideoSkinElement);
